// extracted by mini-css-extract-plugin
export var messageSideLeft = "_p3-1";
export var stateContainer = "_p3-0";